<div>
    <mat-toolbar style="background: #f6f6f6;" matDialogTitle class="m-0">
        <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
          <button class="mr-12" (click)="dialogRef.close(null)" mat-icon-button>
            <mat-icon>close</mat-icon>
          </button>
          <span class="title dialog-title"> Select Icon - {{ (data && data.selectedIcon) || '' }} </span>
          <span fxFlex></span>
          <div fxLayout="row" fxLayoutAlign="start center">
              <label for="search" class="mr-8">
                  <mat-icon>search</mat-icon>
              </label>
              <mat-form-field>
                  <input matInput placeholder="Search" [(ngModel)]="query">
              </mat-form-field>
          </div>
        </div>
      </mat-toolbar>
  <div style="overflow: auto" class="example-card p-24 h-535">
    <div fxLayout="row wrap" class="mb-8">
      <div class="p-8 m-4 happ-icon-container" (click)="dialogRef.close(icon)" *ngFor="let icon of icons | fullTextSearch:query">
        <mat-icon class="font-size-34" style="height: 34px; width: 34px;"> {{ icon }} </mat-icon>
      </div>
    </div>
  </div>
</div>